<template>
  <div>
    <!--to-top-->
    <div class="to-top"><img src="/static/img/to-top.png"/></div>
    <div class="pop-mask"></div>


<!--    <div class="mobile-header">-->
<!--      <div class="wrap">-->
<!--        <div class="m-box">-->
<!--          <div class="logo"><a href="#"><img src="/static/img/logo.png"/></a></div>-->
<!--          <div class="r-box">-->
<!--            <a href="javascript:;" class="apply-data-btn">申请数据</a>-->
<!--            <div class="nav-btn"><span></span><span></span><span></span></div>-->
<!--          </div>-->

<!--          <div class="nav-list">-->
<!--            <ul>-->
<!--              <li class="active"><a href="index.html" class="inNav nav-on">首页</a></li>-->
<!--              <li><a href="参与中心.html" class="inNav nav-on">参与中心</a></li>-->
<!--              <li>-->
<!--                <a href="javascript:;" class="inNav">学术支持</a>-->
<!--                <div class="sub-nav">-->
<!--                  <a href="https://www.cnki.net/">中国知网</a>-->
<!--                  <a href="http://www.wanfangdata.com.cn/index.html">万方数据</a>-->
<!--                  <a href="https://www.ncbi.nlm.noh.gov/">Pubmed</a>-->
<!--                  <a href="https://www.embase.com/login">Embase</a>-->
<!--                  <a href="https://www.cochranelibrary.com/">Cochranelibrary</a>-->
<!--                </div>-->
<!--              </li>-->
<!--              <li><a href="发表论文.html" class="inNav nav-on">发表论文</a></li>-->
<!--              <li><a href="加入我们.html" class="inNav nav-on">加入我们</a></li>-->
<!--            </ul>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="inner-banner center-banner pc-inner-banner"></div>
    <div class="mobile-inner-banner center-banner">
      <img src="/static/img/center-banner.jpg"/>
    </div>
    <div class="inner-main">
      <div class="center-list wrap">
        <h2>截止2022年共计80家参与中心，已录入数据中心按录入量排序，未录入数据中心按拼音顺序排序</h2>
        <br>
        <ul class="wow fadeInDown">
          <li v-for="item in centerData" :key="item.title" >
            <a target="_blank" :href="item.src">
              <img :src="item.imgSrc" :alt="item.title">
            </a>
          </li>
        </ul>
      </div>
    </div>
    <footer class="footer">
      <div class="wrap">
        <a href="#" class="f-logo wow fadeInLeft"><img src="/static/img/f-logo.png"/></a>
        <!--			<p class="wow fadeInRight">地址：北京丰台区汉威广场二区1号楼6M层</p>-->
        <p class="wow fadeInRight">Copyright © 2017-2020 大中华减重与代谢外科数据平台京ICP备17044059号 </p>
        <p>平台支持：<a target="_blank" href="http://www.edocdata.com/">北京易得医数科技有限责任公司</a></p></div>
    </footer>
  </div>
</template>
<script>
require('../../static/js/common.js')
require('../../static/js/swiper.min.js')
require('../../static/js/inner.js')
require('../../static/laydate/laydate.js')
import VueCountUp from 'vue-countupjs'
import {WOW} from 'wowjs'

export default {
  components: {VueCountUp},
  data() {
    return {
      centerData: [
        {
          title: '成都市第三人民医院',
          src: 'http://www.cd3hospital.com/',
          imgSrc: require('../../static/img/participationCenter/cdsdsrm.png'),
        },
        {
          title: '北京友谊医院',
          src: 'http://www.bfh.com.cn/',
          imgSrc: require('../../static/img/participationCenter/bjyy.png'),
        },
        {
          title: '河南省新乡市第二人民医院',
          imgSrc: require('../../static/img/participationCenter/hnxxde.png'),
        },
        {
          title: '中山市小榄人民医院',
          src: 'https://www.xlrmyy.com/',
          imgSrc: require('../../static/img/participationCenter/zssxl.png'),
        },
        {
          title: '安徽医科大学第二附属医院',
          src: 'https://www.ahs2y.com/',
          imgSrc: require('../../static/img/participationCenter/anykdx.png'),
        },
        {
          title: '山东大学齐鲁医院',
          src: 'http://www.qiluhospital.com/',
          imgSrc: require('../../static/img/participationCenter/sdql.png'),
        },
        {
          title: '长春外科嘉和医院',
          imgSrc: require('../../static/img/participationCenter/ccjh.png'),
        },
        {
          title: '北京清华长庚医院.jpeg',
          src: 'http://www.btch.edu.cn/',
          imgSrc: require('../../static/img/participationCenter/bjqhcg.png'),
        },
        {
          title: '上海交通大学医学院附属第九人民医院',
          src: 'http://www.9hospital.com.cn/djy_web/html/djy/portal/index/index.htm',
          imgSrc: require('../../static/img/participationCenter/shjtdj.png'),
        },
        {
          title: '武汉大学中南医院',
          src: 'https://www.znhospital.com/',
          imgSrc: require('../../static/img/participationCenter/whzn.png'),
        },
        {
          title: '河南省人民医院',
          src: 'https://www.hnsrmyy.net/',
          imgSrc: require('../../static/img/participationCenter/hnrm.png'),
        },
        {
          title: '首都医科大学附属北京天坛医院',
          src: 'https://www.bjtth.org/',
          imgSrc: require('../../static/img/participationCenter/bjtt.png'),
        },
        {
          title: '广州中医药大学金沙洲医院',
          src: 'http://www.jsz120.com/',
          imgSrc: require('../../static/img/participationCenter/jsz.png'),
        },
        {
          title: '天津医科大学总医院',
          src: 'http://www.tjmugh.com.cn/',
          imgSrc: require('../../static/img/participationCenter/tjykd.png'),
        },
        {
          title: '中日友好医院',
          src: 'https://www.zryhyy.com.cn/',
          imgSrc: require('../../static/img/participationCenter/zryh.png'),
        },
        {
          title: '吉林大学中日联谊医院',
          src: 'http://www.zrlyyy.com/',
          imgSrc: require('../../static/img/participationCenter/jlzrly.png'),
        },
        {
          title: '昆明市第一人民医院',
          src: 'http://www.kmsdyrmyy.com/index.html',
          imgSrc: require('../../static/img/participationCenter/km.png'),
        },
        {
          title: '山东大学附属济南市中心医院',
          src: 'http://www.zxyy.cn/',
          imgSrc: require('../../static/img/participationCenter/sdjnszx.png'),
        },
        {
          title: '山西白求恩医院',
          src: 'http://www.sxbqeh.com.cn/',
          imgSrc: require('../../static/img/participationCenter/sxbqe.jpg'),
        },
        {
          title: '西安交通大学附属第一医院',
          src: 'http://www.dyyy.xjtu.edu.cn/',
          imgSrc: require('../../static/img/participationCenter/xajtdxfsdy.png'),
        },
        {
          title: '中南大学湘雅三医院',
          src: 'http://www.xy3yy.com/',
          imgSrc: require('../../static/img/participationCenter/hnxyds.png'),
        },
        {
          title: '新疆维吾尔自治区人民医院',
          src: 'http://www.xjrmyy.com/',
          imgSrc: require('../../static/img/participationCenter/xjrmyy.png'),
        },
        {
          title: '联勤保障988',
          imgSrc: require('../../static/img/participationCenter/lq988.jpg'),
        },
        {
          title: '浙江大学医学院附属邵逸夫医院',
          src: 'http://www.srrsh.com/',

          imgSrc: require('../../static/img/participationCenter/zjsyf.png'),
        },
        {
          title: '云南省曲靖市第二人民医院',
          src: 'http://www.qjeyy.cn/yuqjdeyy.png',

          imgSrc: require('../../static/img/participationCenter/yuqjdeyy.png'),
        },
        {
          title: '首都医科大学附属北京世纪坛医院',
          src: 'https://www.bjsjth.cn/',
          imgSrc: require('../../static/img/participationCenter/bjsjt.png'),
        },
        {
          title: '洛阳市中医院',
          src: 'http://www.lydyzy.cn/',
          imgSrc: require('../../static/img/participationCenter/lysyy.png'),
        },
        {
          title: '哈尔滨市第一医院',
          src: 'http://www.hrbsdyyy.com/',
          imgSrc: require('../../static/img/participationCenter/hemd1.png'),
        },
        {
          title: '山东淄博市中心医院',
          src: 'http://www.zbzxyy.com/',
          imgSrc: require('../../static/img/participationCenter/sdzb.png'),
        },
        {
          title: '河北医科大学第二医院',
          src: 'http://www.hb2h.com/',
          imgSrc: require('../../static/img/participationCenter/hbd2.png'),
        },
        {
          title: '唐山市工人医院',
          src: 'https://www.120.org.cn/',
          imgSrc: require('../../static/img/participationCenter/tsgr.png'),
        },
        {
          title: '中国科学技术大学附属第一医院',
          src: 'http://www.ahslyy.com.cn/',
          imgSrc: require('../../static/img/participationCenter/zgkjfsdy.png'),
        },
        {
          title: '徐州医科大学附属医院',
          src: 'http://www.jsxyfy.com/',
          imgSrc: require('../../static/img/participationCenter/xzdyyy.png'),
        },
        {
          title: '内蒙古自治区人民医院',
          src: 'http://www.nmgyy.cn/',
          imgSrc: require('../../static/img/participationCenter/nmgrm.png'),
        },
        {
          title: '北京大学大三医院',
          src: 'https://www.puh3.net.cn/',
          imgSrc: require('../../static/img/participationCenter/bjd3.png'),
        },
        {
          title: '首都医科大学附属北京朝阳医院',
          src: 'https://www.bjcyh.com.cn/',
          imgSrc: require('../../static/img/participationCenter/bjcyds.png'),
        },
        {
          title: '洛阳市中心医院',
          src: 'http://www.lyszxyy.com/',
          imgSrc: require('../../static/img/participationCenter/ly.png'),
        },
        {
          title: '北京医院',
          src: 'http://www.bjhmoh.cn/',
          imgSrc: require('../../static/img/participationCenter/bjh.png'),
        },
        {
          title: '河南科技大学附属第一医院',
          src: 'https://www.hkdyfy.cn/',
          imgSrc: require('../../static/img/participationCenter/hnkjdyyy.png'),
        },
        {
          title: '四川大学华西第四医院',
          src: 'https://wc4hospital.scu.edu.cn/',
          imgSrc: require('../../static/img/participationCenter/hxd4yy.png'),
        },
        {
          title: '湖北省人民医院',
          src: 'http://www.rmhospital.com/',
          imgSrc: require('../../static/img/participationCenter/whrm.png'),
        },
        {
          title: '北京大学人民医院',
          src: 'https://www.pkuph.cn/',
          imgSrc: require('../../static/img/participationCenter/bjrmyy.png'),
        },
        {
          title: '山东大学齐鲁医院(青岛)',
          src: 'http://www.qlyyqd.com/web/Index.aspx',
          imgSrc: require('../../static/img/participationCenter/sdql.png'),
        },
        {
          title: '天津市第三中心医院',
          src: 'http://www.tj3zx.cn/',
          imgSrc: require('../../static/img/participationCenter/tjd3.png'),
        },
        {
          title: '天津市第一中心医院',
          src: 'http://www.tj-fch.com/',
          imgSrc: require('../../static/img/participationCenter/tjyzx.png'),
        },
        {
          title: '天津市南开医院',
          src: 'https://www.tjnkh.com.cn/#/main',
          imgSrc: require('../../static/img/participationCenter/tjnk.png'),
        },
        {
          title: '宁夏医科大学总医院',
          src: 'https://www.nyfy.com.cn/',
          imgSrc: require('../../static/img/participationCenter/nx.png'),
        },
        {
          title: '浙江省人民医院',
          src: 'http://www.hospitalstar.com/',
          imgSrc: require('../../static/img/participationCenter/zjrm.png'),
        },
        {
          title: '湖北省中医院',
          src: 'https://www.hbhtcm.com/',
          imgSrc: require('../../static/img/participationCenter/hbszyy.png'),
        },
        {
          title: '上海交通第六医院',
          src: 'http://www.6thhosp.com/',
          imgSrc: require('../../static/img/participationCenter/shd6.png'),
        },
        {
          title: '复旦大学附属华山医院',
          src: 'https://www.huashan.org.cn/index.html',
          imgSrc: require('../../static/img/participationCenter/hsyy.png'),
        },
        {
          title: '济宁医学院附属医院',
          src: 'http://www.jyfy.com.cn/',
          imgSrc: require('../../static/img/participationCenter/jn.png'),
        },
        {
          title: '安阳市人民医院.png',
          src: 'http://www.no1ayyy.com/',
          imgSrc: require('../../static/img/participationCenter/ayrm.png'),
        },
        {
          title: '北京协和医院',
          src: 'https://www.pumch.cn/index.html',
          imgSrc: require('../../static/img/participationCenter/bjxh.png'),
        },
        {
          title: '河北省沧州中西医结合医院',
          src: 'https://www.cz96130.com/wwwroot/index.asp',
          imgSrc: require('../../static/img/participationCenter/hbczzx.png'),
        },
        {
          title: '国药北方医院',
          src: 'http://www.gybfyy.cn/',
          imgSrc: require('../../static/img/participationCenter/bfyy.png'),
        },
        {
          title: '河北医科大学第一医院',
          src: 'http://www.jyyy.com.cn/',
          imgSrc: require('../../static/img/participationCenter/hb1.png'),
        },
        {
          title: '北京积水潭医院',
          src: 'https://www.jst-hosp.com.cn/',
          imgSrc: require('../../static/img/participationCenter/bjjtyy.png'),
        },
        {
          title: '威海市中心医院',
          src: 'http://www.whszxyy.com.cn/',
          imgSrc: require('../../static/img/participationCenter/whyy.png'),
        },
        {
          title: '北京丰台医院',
          src: 'http://www.bjftyy.com/',
          imgSrc: require('../../static/img/participationCenter/bjft.png'),
        },
        {
          title: '哈尔滨医科大学附属第二医院',
          src: 'http://www.hrbmush.edu.cn/',
          imgSrc: require('../../static/img/participationCenter/hebyy.png'),
        },
        {
          title: '中国医科大学附属第四医院',
          src: 'http://www.cmu4h.cn/',
          imgSrc: require('../../static/img/participationCenter/hbd4.png'),
        },
        {
          title: '西安医学院附属宝鸡医院',
          src: 'http://www.409yy.com/',
          imgSrc: require('../../static/img/participationCenter/xykjdyyy.png'),
        },
        {
          title: '新乡市中心医院',
          src: 'http://www.xxszxyy.com.cn/',
          imgSrc: require('../../static/img/participationCenter/xyrmyy.png'),
        },
        {
          title: '滨州医学院附属医院',
          src: 'http://www.byfy.cn/',
          imgSrc: require('../../static/img/participationCenter/bzyy.png'),
        },
        {
          title: '复旦大学附属中山医院',
          src: 'https://www.zs-hospital.sh.cn/',
          imgSrc: require('../../static/img/participationCenter/fdfszyy.png'),
        },
        {
          title: '空军军医大学附属西京医院',
          src: 'https://xjwww.fmmu.edu.cn/',
          imgSrc: require('../../static/img/participationCenter/kjnyy.png'),
        },
        {
          title: '聊城市人民医院',
          src: 'http://www.lchospital.cn/',
          imgSrc: require('../../static/img/participationCenter/lcrmyy.png'),
        },
        {
          title: '临沂市人民医院',
          src: 'http://ly120.cn/',
          imgSrc: require('../../static/img/participationCenter/ljsyy.png'),
        },
        {
          title: '南京大学医学院附属鼓楼医院',
          src: 'https://www.njglyy.com/',
          imgSrc: require('../../static/img/participationCenter/njglyy.png'),
        },
        {
          title: '山东大学第二医院',
          src: 'https://www.sdey.net/',
          imgSrc: require('../../static/img/participationCenter/sddydeyy.png'),
        },
        {
          title: '山东省立医院',
          src: 'http://www.sph.com.cn/',
          imgSrc: require('../../static/img/participationCenter/sdlyy.png'),
        },
        {
          title: '上海市东方医院',
          src: 'https://www.easthospital.cn/',
          imgSrc: require('../../static/img/participationCenter/shdfyy.png'),
        },
        {
          title: '胜利油田中心医院',
          src: 'http://www.slchos.com:8070/',
          imgSrc: require('../../static/img/participationCenter/slytyy.png'),
        },
        {
          title: '苏州大学附属第一医院总院',
          src: 'http://fyy.sdfyy.cn/',
          imgSrc: require('../../static/img/participationCenter/szdyfsyy.png'),
        },
        {
          title: '苏州明基医院',
          src: 'http://www.benqmedicalcentersz.com/',
          imgSrc: require('../../static/img/participationCenter/szmjyy.png'),
        },{
          title: '潍坊市人民医院',
          src: 'https://www.wfph.cn/',
          imgSrc: require('../../static/img/participationCenter/wfyy.png'),
        },{
          title: '中国人民解放军总医院第一医学中心',
          src: 'https://www.301hospital.com.cn/index.html',
          imgSrc: require('../../static/img/participationCenter/jfyy.png'),
        },{
          title: '中南大学湘雅二医院',
          src: 'https://www.xyeyy.com/',
          imgSrc: require('../../static/img/participationCenter/znyy.png'),
        },{
          title: '遵义医科大学附属医院',
          src: 'https://www.zmuhospital.com/',
          imgSrc: require('../../static/img/participationCenter/zyyy.png'),
        },
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      var wow = new WOW({
        live: false
      })
      wow.init()
    })
  }
}
</script>
<style scoped>
/*@import url('../../static/css/common.css');*/
/*@import url('../../static/css/swiper.min.css');*/
/*@import url('../../static/css/inner.css');*/
/*@import url('../../static/css/respond.css');*/


</style>



// WEBPACK FOOTER //
// src/views/participation_center.vue